import React, { useEffect, useRef } from "react"

const ProjectSubmissionConfirmation = ({
  continueLabel,
  continueUrl,
  message,
  description,
}) => {
  const messageRef = useRef(null)

  useEffect(() => {
    messageRef.current?.focus({ preventScroll: true })

    const reduceMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    )?.matches
    window.scroll({
      top: 0,
      left: 0,
      behavior: reduceMotion ? "auto" : "smooth",
    })
  }, [])

  return (
    <section className="project-submissions-confirmation">
      <div className="project-submissions-confirmation__content">
        <h2
          ref={messageRef}
          className="project-submissions-confirmation__message"
          tabIndex="-1"
        >
          {message}
        </h2>
        <div className="project-submissions-confirmation__ctaWrapper">
          {description ? (
            <p className="project-submissions-confirmation__description">
              {description}
            </p>
          ) : null}
          <a
            className="project-submissions-confirmation__continue"
            href={continueUrl}
          >
            {continueLabel}
          </a>
        </div>
      </div>
    </section>
  )
}

export default ProjectSubmissionConfirmation
